import React from "react";
import { Row, Col, Button, ButtonGroup } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AgGrid from "../../../reusable-components/AgGridComponent/AgGrid";
import { useState, useCallback, useEffect } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import Modal from "react-bootstrap/Modal";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import * as Icon from "react-bootstrap-icons";
import Select from "react-select";
import { ThreeCircles } from "react-loader-spinner";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { getFromLS } from "../../../utils/storage";
import { logout } from "../../../utils";

require("highcharts/modules/accessibility")(Highcharts);

export const OptimiseChartModal = (props) => {
  const [originalSeries, setOriginalSeries] = useState([]);
  const [originalCategories, setOriginalCategories] = useState([]);
  const [optimiseSeries, setOptimiseSeries] = useState([]);
  const [optimiseCategories, setOptimiseCategories] = useState([]);
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));
  const [vendor, setVendor] = useState("xcm");
  const [revisedSchedule, setRevisedSchedule] = useState([]);

  const [optimiseRowData, setOptimiseRowData] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [optimzeOn, setOptimizeOn] = useState([]);
  const [selectedoptimizeOn, setSelectedoptimizeOn] = useState({});
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [optimizedReportLoader, setOptimizedReportLoader] = useState(false);
  const [originalReportLoader, setOriginalReportLoader] = useState(false);
  const [parameterDescription, setParameterDescription] = useState("");
  const localChartTheme = getFromLS("chart-theme");

  // Change the column defs according to API data
  const [optimiseColumnDefs, setOptimiseColumnDefs] = useState([
    { field: "name", enablePivot: true, pinned: "left", lockPinned: true },
    {
      field: "role",
      enablePivot: true,
      pinned: "left",
      lockPinned: true,
      maxWidth: 100,
    },
    {
      headerName: "Assigned",
      children: [
        { field: "budget ", maxWidth: 150 },
        {
          field: "budget optimized ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
        { field: "actual ", maxWidth: 150 },
        {
          field: "actual optimized ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
      ],
      enablePivot: true,
    },
    {
      headerName: "Extension",
      children: [
        { field: "budget  ", maxWidth: 150 },
        {
          field: "budget optimized  ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
        { field: "actual  ", maxWidth: 150 },
        {
          field: "actual optimized  ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
      ],
      enablePivot: true,
    },
    {
      headerName: "Not Ready for Prep",
      children: [
        { field: "budget   ", maxWidth: 150 },
        {
          field: "budget optimized   ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
        { field: "actual   ", maxWidth: 150 },
        {
          field: "actual optimized   ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
      ],
      enablePivot: true,
    },
    {
      headerName: "N/A",
      children: [
        { field: "budget    ", maxWidth: 150 },
        {
          field: "budget optimized    ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
        { field: "actual    ", maxWidth: 150 },
        {
          field: "actual optimized    ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
      ],
      enablePivot: true,
    },
    {
      headerName: "Total",
      children: [
        { field: "budget     ", maxWidth: 150 },
        {
          field: "budget optimized     ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
        { field: "actual     ", maxWidth: 150 },
        {
          field: "actual optimized     ",
          maxWidth: 150,
          cellStyle: { color: "black", "background-color": "#CCE9EA" },
        },
      ],
      enablePivot: true,
    },
    { field: "experience", enablePivot: true },
    { field: "title", enablePivot: true },
  ]);
  const sortable = true;
  const filter = true;
  const resizable = true;

  const zeroIfNull = (x) => {
    if (isNaN(x)) {
      return 0;
    }
    return x;
  };

  useEffect(() => {
    if (!originalReportLoader && !optimizedReportLoader)
      console.log("Printing This as its now false");

    var isSyncingLeftScroll = false;
    var isSyncingRightScroll = false;
    var leftDiv = document.getElementsByClassName("highcharts-scrollbar")[1];
    var rightDiv = document.getElementsByClassName("highcharts-scrollbar")[2];

    if (leftDiv) {
      leftDiv.onscroll = function () {
        console.log("left div");
        if (!isSyncingLeftScroll) {
          isSyncingRightScroll = true;
          rightDiv.scrollTop = this.scrollTop;
        }
        isSyncingLeftScroll = false;
      };
    }

    if (rightDiv) {
      rightDiv.onscroll = function () {
        console.log("right div");
        if (!isSyncingRightScroll) {
          isSyncingLeftScroll = true;
          leftDiv.scrollTop = this.scrollTop;
        }
        isSyncingRightScroll = false;
      };
    }
  }, [originalReportLoader, optimizedReportLoader]);

  const fetchOriginalData = () => {
    setOriginalReportLoader(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, vendor }),
    };

    return fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/staffing/`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => {
        setOriginalBarData(result);
        setOriginalReportLoader(false);
        return result;
      });
  };

  const fetchParameters = () => {
    let token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    if (token) {
      return fetch(
        `${process.env.REACT_APP_BASE_URI}/api/data/staffing/optimize_parameters/`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((result) => {
          setParameterDescription(result.data[0].parameters_description);
          setParameters(result.data[0].parameters);
          setOptimizeOn(result.data[0].optimize_on);
        });
    }
  };

  useEffect(() => {
    fetchParameters();
  }, []);

  let setOptimiseGridData = (result) => {
    setRevisedSchedule(result.data[0].report.optimized_schedule);
    console.log("RESUKT", result);
    // Write logic to display optimise data grid
    const staff = result.data[0].report.staff;

    setOptimizeBarData(result);
    const grid_data = [];
    for (let name in staff) {
      const data = {
        name: name,
        role: staff[name].role,
        title: staff[name].title,
        experience: staff[name].experience,
        "budget ": staff[name]["Assigned"].budget,
        "budget optimized ": staff[name]["Assigned"].budgetOptimized,
        "actual ": staff[name]["Assigned"].actual,
        "actual optimized ": staff[name]["Assigned"].actualOptimized,
        "budget  ": staff[name]["Extension"].budget,
        "budget optimized  ": staff[name]["Extension"].budgetOptimized,
        "actual  ": staff[name]["Extension"].actual,
        "actual optimized  ": staff[name]["Extension"].actualOptimized,
        "budget   ": staff[name]["N/A"].budget,
        "budget optimized    ": staff[name]["N/A"].budgetOptimized,
        "actual   ": staff[name]["N/A"].actual,
        "actual optimized    ": staff[name]["N/A"].actualOptimized,
        "budget    ": staff[name]["Not Ready for Prep"].budget,
        "budget optimized   ":
          staff[name]["Not Ready for Prep"].budgetOptimized,
        "actual    ": staff[name]["Not Ready for Prep"].actual,
        "actual optimized   ":
          staff[name]["Not Ready for Prep"].actualOptimized,
        "budget     ": staff[name]["total"].budgeted,
        "budget optimized     ": staff[name]["total"].budgetOptimized,
        "actual     ": staff[name]["total"].actual,
        "actual optimized     ": staff[name]["total"].actualOptimized,
      };
      grid_data.push(data);
    }
    setOptimiseRowData(grid_data);
    return staff;
  };

  let setOriginalBarData = (result) => {
    const staff = result.data[0].report.staff;
    const yellow = [];
    const blue = [];
    const gray = [];
    const orange = [];
    const categories = [];
    for (let name in staff) {
      let staff_name = staff[name];
      let total = zeroIfNull(
        Math.round(
          (staff_name["total"]["budgeted"] - staff_name["total"]["actual"]) * 10
        ) / 10
      );
      let assigned = zeroIfNull(
        Math.round(
          (staff_name["Assigned"]["budget"] -
            staff_name["Assigned"]["actual"]) *
            10
        ) / 10
      );
      let extension = zeroIfNull(
        Math.round(
          (staff_name["Extension"]["budget"] -
            staff_name["Extension"]["actual"]) *
            10
        ) / 10
      );
      let not_ready = zeroIfNull(
        Math.round(
          (staff_name["Not Ready for Prep"]["budget"] -
            staff_name["Not Ready for Prep"]["actual"]) *
            10
        ) / 10
      );
      yellow.push(total);
      blue.push(assigned);
      gray.push(extension);
      orange.push(not_ready);
      categories.push(name);
    }

    const barChartData = [
      { data: yellow, name: "Total", color: "#ff793f" },
      { data: blue, name: "Assigned", color: "#34ace0" },
      { data: gray, name: "Extension", color: "#706fd3" },
      { data: orange, name: "Not ready for prep", color: "#ffda79" },
    ];
    setOriginalCategories(categories);
    setOriginalSeries(barChartData);
  };

  let setOptimizeBarData = (result) => {
    // Write logic to get data from optimise api and render for chart
    const staff = result.data[0].optimized_data;
    console.log("staff", staff);
    const yellow = [];
    const blue = [];
    const gray = [];
    const orange = [];
    const categories = [];
    for (let name in staff) {
      let staff_name = staff[name];
      let total = zeroIfNull(
        Math.round(
          (staff_name["total"]["budgeted"] - staff_name["total"]["actual"]) * 10
        ) / 10
      );
      let assigned = zeroIfNull(
        Math.round(
          (staff_name["Assigned"]["budget"] -
            staff_name["Assigned"]["actual"]) *
            10
        ) / 10
      );
      let extension = zeroIfNull(
        Math.round(
          (staff_name["Extension"]["budget"] -
            staff_name["Extension"]["actual"]) *
            10
        ) / 10
      );
      let not_ready = zeroIfNull(
        Math.round(
          (staff_name["Not Ready for Prep"]["budget"] -
            staff_name["Not Ready for Prep"]["actual"]) *
            10
        ) / 10
      );
      yellow.push(total);
      blue.push(assigned);
      gray.push(extension);
      orange.push(not_ready);
      categories.push(name);
    }

    const barChartData = [
      { data: yellow, name: "Total", color: "#ff793f" },
      { data: blue, name: "Assigned", color: "#34ace0" },
      { data: gray, name: "Extension", color: "#706fd3" },
      { data: orange, name: "Not ready for prep", color: "#ffda79" },
    ];
    setOptimiseCategories(categories);
    setOptimiseSeries(barChartData);
  };
  // const chart2 = <HighchartsReact highcharts={Highcharts} options={optimiseOptions} />
  const optimiseOptions = {
    chart: {
      type: "bar",
      height: 520,
      backgroundColor: "var(--card_body_color)",
      color: "var(--text_color)",
    },
    colors: localChartTheme.colors,
    title: {
      text: "Optimized staffing hours",
      style: {
        textOutline: false,
        color: "var(--text_color)",
      },
    },
    xAxis: {
      type: "category",
      min: 0,
      max: 2,
      categories: optimiseCategories,
      gridLineWidth: 1,
      tickInterval: 1,
      tickmarkPlacement: "between",
      title: {
        text: null,
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      scrollbar: {
        enabled: true,
      },
      tickLength: 0,
      tickWidth: 1,
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
    //   events: {
    //     setExtremes: function(e) {
    //         if (!chart2)
    //             return;
            
    //         chart2.xAxis[0].setExtremes(e.min, e.max);
    //     }
    // }
    },
    yAxis: {
      min: -1000,
      max: 500,
      title: {
        align: "high",
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          colorByPoint: true,
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
      },
      series: {
        pointWidth: 10,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: true,
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)",
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: optimiseSeries,
  };

  const originalOptions = {
    chart: {
      type: "bar",
      height: 520,
      backgroundColor: "var(--card_body_color)",
      color: "var(--text_color)",
    },
    navigator: {
      enabled: false   
  },
  scrollbar: {
      enabled: false   
  },
  rangeSelector: {
      enabled: false   
  },
    title: {
      text: "Current staffing hours",
      style: {
        textOutline: false,
        color: "var(--text_color)",
      },
    },
    xAxis: {
      type: "category",
      min: 0,
      max: 2,
      categories: originalCategories,
      gridLineWidth: 1,
      tickInterval: 1,
      tickmarkPlacement: "between",
      title: {
        text: null,
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      scrollbar: {
        enabled: true,
      },
      tickLength: 0,
      tickWidth: 1,
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
    },
    yAxis: {
      min: -1000,
      max: 500,
      title: {
        align: "high",
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
    },
    colors: localChartTheme.colors,
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          colorByPoint: true,
          style: { textOutline: false, color: "var(--text_color)" },
        },
      },
      series: {
        pointWidth: 10,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: true,
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)",
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: originalSeries,
  };

  let optGridApi;
  const getApiData = useCallback((params) => {
    optGridApi = params.api;
    console.log("optGridApi", optGridApi);
  }, []);

  const parametersOptions =
    parameters &&
    parameters.map((el, i) => {
      return {
        value: el,
        label: el,
        id: i,
      };
    });

  const optimizeOnOptions =
    optimzeOn &&
    optimzeOn.map((el, i) => {
      return {
        value: el,
        label: el,
        id: i,
      };
    });

  const runOptimizedReport = () => {
    setOptimizedReportLoader(true);
    setOriginalReportLoader(true);

    const requestOptions1 = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firm_id,
        vendor,
        parameters: [selectedoptimizeOn && selectedoptimizeOn.value],
        optimize_on:
          selectedParameters && selectedParameters.map((el) => el.value),
      }),
    };

    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/staffing/optimize_combined/`,
      requestOptions1
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => {
        console.log("RESULT : ", result);

        setOptimizedReportLoader(false);
        setOriginalReportLoader(false);

        let originalData = result.data[0].report.staff;
        let optimizedData = result.data;
        let originalResult = result;

        console.log("ORIGINAL DATA : ", originalData, result.data);

        // add optimized in this api
        originalResult.data[0].optimized_data =
          optimizedData[0].report.optimized;

        for (const [key, value] of Object.entries(originalData)) {
          let optimizedDataValues = optimizedData[0].report.optimized[key];

          console.log("value and valueassigned", key, value, value["Assigned"]);

          if (
            value &&
            value["Assigned"] &&
            value["Extension"] &&
            value["N/A"] &&
            value["Not Ready for Prep"] &&
            value["total"]
          ) {
            if (value && value["Assigned"]) {
              value["Assigned"]["actualOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["Assigned"]["actual"]
                : "null";
            }
            if (value && value["Assigned"]) {
              value["Assigned"]["budgetOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["Assigned"]["budget"]
                : "null";
            }

            if (value && value["Extension"]) {
              value["Extension"]["actualOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["Extension"]["actual"]
                : "null";
            }
            if (value && value["Extension"]) {
              value["Extension"]["budgetOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["Extension"]["budget"]
                : "null";
            }

            if (value && value["N/A"]) {
              value["N/A"]["actualOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["N/A"]["actual"]
                : "null";
            }
            if (value && value["N/A"]) {
              value["N/A"]["budgetOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["N/A"]["budget"]
                : "null";
            }

            if (value && value["Not Ready for Prep"]) {
              value["Not Ready for Prep"]["actualOptimized"] =
                optimizedDataValues
                  ? optimizedData[0].report.optimized[key][
                      "Not Ready for Prep"
                    ]["actual"]
                  : "null";
            }

            if (value && value["Not Ready for Prep"]) {
              value["Not Ready for Prep"]["budgetOptimized"] =
                optimizedDataValues
                  ? optimizedData[0].report.optimized[key][
                      "Not Ready for Prep"
                    ]["budget"]
                  : "null";
            }

            if (value && value["total"]) {
              value["total"]["actualOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["total"]["actual"]
                : "null";
            }
            if (value && value["total"]) {
              value["total"]["budgetOptimized"] = optimizedDataValues
                ? optimizedData[0].report.optimized[key]["total"]["budgeted"]
                : "null";
            }
          }
        }

        setOriginalBarData(result);
        setOptimiseGridData(originalResult);
      });
    // });
  };
  const onBtOptExcelExport = useCallback(() => {
    optGridApi.exportDataAsExcel();
    console.log("optGridApi", optGridApi);
  }, []);

  const onBtOptCSVExport = useCallback(() => {
    optGridApi.exportDataAsCsv();
  }, []);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const popoverRenderContent = Object.entries(parameterDescription).map(
    ([key, value], i) => (
      <div key={key}>
        <span style={{ fontWeight: "600" }}>{value.name}</span>:{" "}
        {value.description}
      </div>
    )
  );

  const downloadOptimizedSchedule = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const popover_1 = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Roles</Popover.Header>
      <Popover.Body>
        Select a role for optimizing the respective schedules. You can select a
        single role or all roles together to be optimized.
      </Popover.Body>
    </Popover>
  );

  const popover_2 = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Parameters</Popover.Header>
      <Popover.Body>{popoverRenderContent}</Popover.Body>
    </Popover>
  );

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      className={"comparison-modal"}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Optimized Staffing chart
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row style={{ margin: "15px 0" }}>
          <Col xs={3}></Col>
          <Col xs={3}>
            <h5>
              <label>Optimize for role &nbsp;</label>
              <OverlayTrigger
                trigger="click"
                placement="right"
                overlay={popover_1}
              >
                <Button className="tooltip-pop">
                  <Icon.PatchQuestionFill />{" "}
                </Button>
              </OverlayTrigger>
            </h5>
            <Select
              defaultValue={selectedoptimizeOn}
              onChange={setSelectedoptimizeOn}
              options={optimizeOnOptions}
            />
          </Col>
          <Col xs={3}>
            <h5>
              <label>Optimize based on &nbsp;</label>
              <OverlayTrigger
                trigger="click"
                placement="right"
                overlay={popover_2}
              >
                <Button className="tooltip-pop">
                  <Icon.PatchQuestionFill />{" "}
                </Button>
              </OverlayTrigger>
            </h5>
            <Select
              defaultValue={selectedParameters}
              onChange={setSelectedParameters}
              options={parametersOptions}
              isMulti
            />
          </Col>
          <Col xs={3}>
            <Button
              disabled={
                (selectedoptimizeOn && selectedoptimizeOn.value == undefined
                  ? true
                  : false) && (selectedParameters.length == 0 ? true : false)
              }
              onClick={runOptimizedReport}
              style={{ marginTop: "30px", background: "var(--theme1_primary)" }}
            >
              {" "}
              Optimize{" "}
            </Button>
          </Col>
        </Row>
        <Tabs
          defaultActiveKey="chart"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="chart" title="Chart" className="tabs">
            <DropdownButton
              as={ButtonGroup}
              onClick={(e) =>
                downloadOptimizedSchedule(revisedSchedule, "Revised_Schedules")
              }
              className="reset-button download-excel"
              title="Export Optimized Schedules"
              disabled={
                (selectedoptimizeOn && selectedoptimizeOn.value == undefined
                  ? true
                  : false) && (selectedParameters.length == 0 ? true : false)
              }
            ></DropdownButton>

            <Row>
              <Col md="6">
                <div className="chart-container">
                  {originalReportLoader ? (
                    <div
                      style={{ position: "relative", top: "50px", left: "43%" }}
                    >
                      <ThreeCircles
                        height="100"
                        width="100"
                        color="#4fa94d"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="three-circles-rotating"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_secondary)"
                        middleCircleColor="var(--theme1_tertiary)"
                      />
                      <h5
                        style={{
                          position: "relative",
                          left: "-15%",
                          padding: "10px",
                        }}
                      >
                        Generating Current Staffing Hours Report
                      </h5>
                    </div>
                  ) : (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={originalOptions}
                      id={"left"}
                    />
                  )}
                </div>
              </Col>
              <Col md="6">
                <div className="chart-container">
                  {optimizedReportLoader ? (
                    <div
                      style={{ position: "relative", top: "50px", left: "43%" }}
                    >
                      <ThreeCircles
                        height="100"
                        width="100"
                        color="#4fa94d"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="three-circles-rotating"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_secondary)"
                        middleCircleColor="var(--theme1_tertiary)"
                      />
                      <h5
                        style={{
                          position: "relative",
                          left: "-14%",
                          padding: "10px",
                        }}
                      >
                        Generating optimized Staffing Hours Report
                      </h5>
                    </div>
                  ) : (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={optimiseOptions}
                      id={"right"}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="grid" title="Grid" className="tabs">
            <DropdownButton
              as={ButtonGroup}
              className="reset-button download-excel"
              title=" Export"
              id="bg-nested-dropdown"
              drop="start"
            >
              <Dropdown.Item onClick={onBtOptExcelExport}>
                {" "}
                <Icon.FileExcel /> Excel Export
              </Dropdown.Item>
              <Dropdown.Item onClick={onBtOptCSVExport}>
                {" "}
                <Icon.FiletypeCsv /> CSV Export
              </Dropdown.Item>
            </DropdownButton>
            <Row>
              <Col md="12" className="grid-row staffing">
                <AgGrid
                  rowData={optimiseRowData}
                  columnDefs={optimiseColumnDefs}
                  sortable={sortable}
                  filter={filter}
                  resizable={resizable}
                  onGridReady={getApiData}
                />
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Modal.Body>
      {/* <Modal.Footer>
          <Button className="show-button" onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer> */}
    </Modal>
  );
};
